// assets
import { BuildOutlined, AppstoreOutlined, AppstoreAddOutlined, HeatMapOutlined, ExclamationCircleOutlined, QuestionCircleFilled } from '@ant-design/icons';
// icons
const icons = {
  BuildOutlined,
  AppstoreOutlined,
  AppstoreAddOutlined,
  HeatMapOutlined,
  ExclamationCircleOutlined,
  QuestionCircleFilled
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const menuItems = {
  id: 'exam-management',
  title: 'Thư viện bài thi',
  type: 'group',
  visible: false,
  children: [
    {
      id: 'exam',
      title: 'Bài thi',
      type: 'item',
      url: '/',
      icon: icons.BuildOutlined,
      target: false,
      visible: false
    },
  ]
};

export default menuItems;
